<cap-content-header>
  <cap-title>
    {{ "alte-grundbuchmeldung.ListTitel" | translate }}
  </cap-title>
</cap-content-header>

<div class="my-4">
  @if (listLoader) {
    <div>
      <cap-list-loader [listLoader]="listLoader">
        <div class="cap-list-loader-content">
          <table class="cap-table-search">
            <thead>
              <ng-template [ngTemplateOutlet]="tableHeaders"></ng-template>
            </thead>
            <tbody>
              <ng-template [ngTemplateOutlet]="tableRows"></ng-template>
            </tbody>
          </table>
        </div>
      </cap-list-loader>
    </div>
  } @else {
    <cap-spinner-small></cap-spinner-small>
  }
</div>

<ng-template #tableHeaders>
  <tr>
    <th>
      <cap-column-header [columnName]="'Tagebuchnummer'" [sortModel]="tableSortModel.columns.get('geschaeftsNummer')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'MeldungsId'" [sortModel]="tableSortModel.columns.get('meldungsId')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Abschlussdatum'" [sortModel]="tableSortModel.columns.get('abschlussdatum')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Beschreibung'" [sortModel]="tableSortModel.columns.get('beschreibung')"></cap-column-header>
    </th>
    <th>
      <cap-column-header [columnName]="'Grundstueck'" [sortModel]="tableSortModel.columns.get('grundstueck')"></cap-column-header>
    </th>
    <th>
      {{ "Meldung" | translate }}
    </th>
  </tr>
</ng-template>

<ng-template #tableRows>
  @for (item of listLoader?.items; track item) {
    <tr>
      <td>
        {{ item.object.geschaeftsnummer | formatGeschaeftsnummer }}
      </td>
      <td>
        {{ item.object.meldungsId }}
      </td>
      <td>
        {{ item.object.abschlussDatum | datum }}
      </td>
      <td>
        {{ item.object.beschreibung }}
      </td>
      <td>
        {{ item.object.grundstueck | grundstuecknummerExtended }}
      </td>
      <td>
        <cap-dokulink [item]="item.dokulinkItem"></cap-dokulink>
      </td>
    </tr>
  }
</ng-template>
